<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateShowResponsibleForTab(value: boolean) {
  await settingsStore.set('worksheetsShowResponsibleTab', value);

  if (value === false && settingsStore.settings.worksheetsStartTab === StartTabSetting.responsibleFor) {
    await settingsStore.set('worksheetsStartTab', StartTabSetting.mine);
  }
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.worksheetsShowResponsibleTab"
    :label="t('settings.worksheets.showResponsibleTab')"
    :description="t('settings.worksheets.showResponsibleTabDescription')"
    @change="updateShowResponsibleForTab"
  />
</template>

<style scoped></style>
